function objectHasKey(obj, key) {
    return typeof obj === 'object' && obj !== null && key in obj;
}
function isErrorWithMessage(error) {
    return objectHasKey(error, 'message') && typeof error.message === 'string';
}
/**
 * Turns the given 'unknown' error into an ErrorWithMessage.
 * @param maybeError the error to turn into an ErrorWithMessage
 * @returns the ErrorWithMessage
 * @example
 * try {}
 * catch (error) {
 *   const errorWithMessage = toErrorWithMessage(error)
 *   console.log(errorWithMessage.message)
 * }
 */
function toErrorWithMessage(maybeError) {
    return {
        message: isErrorWithMessage(maybeError)
            ? maybeError.message
            : String(maybeError),
        exception: maybeError,
    };
}
export { toErrorWithMessage };
